let hostInstance = null

export function setBloomSurveyHost (vm) {
  hostInstance = vm || null
}

export function getBloomSurveyHost () {
  return hostInstance
}



// WEBPACK FOOTER //
// ./src/plugin/BloomSurveyDialog/host.js